export function createGlobalFactory<Instance extends { version: number }>(
    globalKey: keyof Window,
    factory: () => Instance,
    version: number,
    allowConflict?: boolean
): () => Instance {
    let localInstance: Instance;
    return (): Instance => {
        const descriptor = Reflect.getOwnPropertyDescriptor(window, globalKey);

        if (descriptor) {
            let val: Instance | undefined = undefined;
            let cannotGetV = false;

            if ('value' in descriptor) {
                val = descriptor.value;
            } else if (descriptor.get) {
                val = descriptor.get();
            } else {
                cannotGetV = true;
            }

            if (!cannotGetV && val?.version === version) {
                return val;
            }

            if (allowConflict) {
                if (!localInstance) {
                    localInstance = factory();
                }
                console.warn(`Create a new instance named ${globalKey} in conflict with the existing one.`);
                return localInstance;
            } else {
                throw Error(`Version(${version}) in conflict with global.${globalKey}.`);
            }
        }

        const globalInstance = factory();

        Object.defineProperty(window, globalKey, {
            value: globalInstance,
            configurable: false,
            writable: false,
            enumerable: false,
        });

        return globalInstance;
    };
}
